import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StockMovement, StockMovementCreate, StockMovementFilter } from '../data/stockMovement';

export function createStockMovementService(client: AxiosInstance) {
  return createCrudService<StockMovement, StockMovementCreate, StockMovementFilter>(client, '/StockMovement', 'stockMovementId');
}

export type StockMovementService = CrudService<StockMovement, StockMovementCreate, StockMovementFilter>;
